/**
 * API 페이로드 직렬화 유틸리티
 *
 * JSON.parse(JSON.stringify) 를 통해 undefined 키 제거, 함수 제거 등
 * JSON 호환 형태로 정제합니다. API 요청 바디/쿼리 생성에 사용합니다.
 *
 * 주의: 배열 내 undefined는 null로 변환됩니다.
 */
export function serializeApiPayload<T>(obj: T): T {
  return JSON.parse(JSON.stringify(obj));
}

/** @deprecated serializeApiPayload 로 교체하세요 */
export const removeUndefined = serializeApiPayload;
